// extracted by mini-css-extract-plugin
export var changeIcon = "_69-4";
export var container = "_69-0";
export var divider = "_69-7";
export var externalLinkIcon = "_69-1";
export var green = "_69-5";
export var helpCircleIcon = "_69-3";
export var iconButton = "_69-2";
export var red = "_69-6";